import React from 'react';

function Challenge() {
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div>
              <h4 className="mb-30">01 . The Challenge</h4>
              <div className="text">
                <h5 className="mb-50 fw-400 line-height-40">
                  The goal is there are many variations of passages of Lorem
                  Ipsum available, but the majority have suffered alteration.
                </h5>
                <div className="row justify-content-end">
                  <div className="col-lg-9">
                    <p className="fz-18">
                      There are many variations of passages of Lorem Ipsum
                      available, but the majority have suffered alteration in
                      some form, by injected humour, or randomised words which
                      don&apos;t look even slightly believable. If you are going
                      to use a passage of Lorem Ipsum, you need to be sure there
                      isn&apos;t anything.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Challenge;
